export default __webpack_public_path__ + "25404c8ae6563d30d316cce4a9bc4ca8.svg";